<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar v-if="token > ''" type="sidebar" :sidebar-links="$sidebar.sidebarLinks"></side-bar>

    <div v-if="token > ''" class="main-panel" style="background-image: url('/img/covid_3.jpg'); width: 100%; background-position: center; position: relative; background-repeat: repeat; background-size: cover;">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar">  </dashboard-content>
      <content-footer></content-footer>
    </div>

    <div v-else class="">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar">  </dashboard-content>
    </div>

    <modal :show.sync="modal_login" headerClasses="justify-content-center" :show-close="false">
            <div class="ml-auto mr-auto">
              <form @submit.prevent="a_login({email:form.email,password:form.password})">
                <card type="login">
                  <h3 slot="header" class="header text-center">Login </h3>
                  <fg-input v-model="form.email" addon-left-icon="nc-icon nc-single-02" placeholder="e-mail is your username..."></fg-input>
                  <fg-input v-model="form.password" addon-left-icon="nc-icon nc-key-25" placeholder="Password" type="password"></fg-input>
                  <br>
                  <div class="row">
                    <p-button native-type="button" type="danger" slot="footer" block class="col-3 mb-3 ml-auto mr-auto" @click.native="m_modal_login(false)">Close</p-button>
                    <p-button native-type="submit" slot="footer" type="info" block class="col-6 mb-3 ml-auto mr-auto">Login</p-button>
                  </div>

                  <div class="row">
                    <p-button native-type="button" slot="footer" type="neutral" block class="col-6 mb-3 ml-auto mr-auto" @click.native="m_modal_login(false); m_modal_forgot(true)"> Forgot your password? </p-button>
                  </div>
                </card>
              </form>
            </div>
    </modal>

    <modal :show.sync="modal_forgot" headerClasses="justify-content-center" :show-close="false">
            <div class="ml-auto mr-auto">
              <ValidationObserver v-slot="{ invalid }">
              <form @submit.prevent="a_forgot({email:form_forgot.email})">
                <card type="login">
                  <h3 slot="header" class="header text-center"> Did you forget your password? </h3>
                    <ValidationProvider name="E-mail" rules="required|email" v-slot="{ errors }">
                      <fg-input v-model="form_forgot.email" addon-left-icon="nc-icon nc-single-02" placeholder="put your email here - we'll send to you secure link to repair your password immediatelly"></fg-input>
                      <span>{{ errors[0] }}</span>
                    </ValidationProvider>
                    <br>
                  <div class="row">
                    <p-button native-type="button" type="danger" slot="footer" block class="col-3 mb-3 ml-auto mr-auto" @click.native="m_modal_forgot(false)">Close</p-button>
                    <p-button native-type="submit" slot="footer" type="success" block class="col-6 mb-3 ml-auto mr-auto" :disabled="invalid"> Send </p-button>
                  </div>
                </card>
              </form>
              </ValidationObserver>
            </div>
    </modal>

    <modal :show.sync="modal_reg" headerClasses="justify-content-center" :show-close="false">
            <div class="ml-auto mr-auto">
              <ValidationObserver v-slot="{ invalid }">
              <form @submit.prevent="onSubmit_reg">
                <card type="signup" class="text-center">
                  <template slot="header">
                    <h3 class="card-title"> Registration </h3>
                  </template>

                  <div class="row">
                    <div class="col-6">
                      <fg-input v-model="form_reg.degrees_1" addon-left-icon="fas fa-user-graduate" placeholder="Title before name"></fg-input>
                    </div>
                    <div class="col-6"></div>
                  </div>

                  <div class="row">
                    <div class="col-6">
                      <fg-input v-model="form_reg.firstName" addon-left-icon="fas fa-signature" placeholder="Name"></fg-input>
                    </div>
                    <div class="col-6">
                      <fg-input v-model="form_reg.lastName" addon-left-icon="fas fa-signature" placeholder="Surname"></fg-input>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-6">
                    </div>
                    <div class="col-6">
                      <fg-input v-model="form_reg.degrees_2" addon-left-icon="fas fa-user-graduate" placeholder="Title after name"></fg-input>
                    </div>
                    <div class="col-6"></div>
                  </div>

                  <div class="row">
                    <div class="col-6">
                      <ValidationProvider rules="required|confirmed:form_reg.verify|min:6" v-slot="{ errors }">
                        <fg-input v-model="form_reg.password" addon-left-icon="fas fa-fingerprint" placeholder="Password" type="password"></fg-input>
                        <span>{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                    <div class="col-6">
                      <ValidationProvider v-slot="{ errors }" vid="form_reg.verify">
                        <fg-input v-model="form_reg.verify" addon-left-icon="fas fa-fingerprint" placeholder="Verify password" type="password"></fg-input>
                        <span>{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-6">
                      <ValidationProvider name="E-mail" rules="required|email" v-slot="{ errors }">
                        <fg-input v-model="form_reg.email" type="email" addon-left-icon="far fa-envelope" placeholder="E-mail"></fg-input>
                        <span>{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                    <div class="col-6">
                      <fg-input v-model="form_reg.phone" addon-left-icon="fas fa-mobile-alt" placeholder="Phone"></fg-input>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-6">
                    </div>
                  </div>

                  <p-checkbox class="text-left" v-model="form_reg.acceptTerms">
                    Confirm your acceptance of
                    <a href="/terms_conditions" target="_blank">the terms and conditions</a>, please.
                  </p-checkbox>

                  <div class="row">
                    <p-button native-type="button" type="danger" slot="footer" block class="col-3 mb-3 ml-auto mr-auto" @click.native="m_modal_reg(false)">Close</p-button>
                    <p-button native-type="submit" slot="footer" type="success" block class="col-6 mb-3 ml-auto mr-auto" :disabled="invalid"> Register </p-button>
                  </div>
                </card>
              </form>
              </ValidationObserver>
            </div>
    </modal>

    <modal :show.sync="modal_info" headerClasses="justify-content-center" :show-close="false">
              <div slot="header" class="modal-profile d-flex justify-content-center align-items-center">
                <i class="fas fa-times-circle"></i>
              </div>
                  <p>{{ modal_info_text }}</p>
                  <template slot="footer">
                    <p-button type="success" link @click.native="m_modal_info(false)">Close</p-button>
                  </template>
    </modal>

    <modal :show.sync="modal_gisaid" headerClasses="justify-content-center">
      <div class="ml-auto mr-auto">
        <form @submit.prevent="a_gisaid({g_username:g_form.g_username, g_password:g_form.g_password, g_clientid:g_form.g_clientid})">
          <card type="login">
            <h3 slot="header" class="header text-center">Insert GISAID Credentials </h3>
            <fg-input label="Username" labelClasses="mylabel" v-model="g_form.g_username" addon-left-icon="" placeholder="insert your GISAID username here ..."></fg-input>
            <fg-input label="Password" labelClasses="mylabel" v-model="g_form.g_password" addon-left-icon="" placeholder="insert your GISAID password here ..." type="password"></fg-input>
            <fg-input label="Client ID" labelClasses="mylabel" v-model="g_form.g_clientid" addon-left-icon="" placeholder="insert your GISAID Client ID here ..."></fg-input>
            <br>
            <div class="row">
              <p-button native-type="button" type="danger" slot="footer" block class="col-3 mb-3 ml-auto mr-auto" @click.native="m_modal_gisaid(false)">Close</p-button>
              <p-button native-type="submit" slot="footer" type="success" block class="col-6 mb-3 ml-auto mr-auto">Save </p-button>
            </div>

            <div class="row">
            </div>
          </card>
        </form>
      </div>
    </modal>


  </div>

</template>

<style lang="scss">

</style>

<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import Modal from '../UIComponents/Modal'
  import Button from '../UIComponents/Button'
  // import UserMenu from 'src/components/UIComponents/SidebarPlugin/UserMenu.vue'
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
  import axios from 'axios';
  import VueNotify from 'vue-notifyjs'

  import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
  import { required, email, confirmed, min } from 'vee-validate/dist/rules';

  extend('required', {
      ...required,
      message: 'This field is required!'
  });

  extend('email', {
      ...email,
      message: 'Invalid e-mail pattern.'
  });

  extend('min', {
      ...min,
      message: 'At least 6 chars is required.'
   });

  extend('confirmed', {
      ...confirmed,
      message: 'Passwords are different.'
  });

  export default {
    data(){
        return {
          form: {
            email: "",
            password: "",
          },
          form_reg: {
            degrees_1: "",
            firstName: "",
            lastName: "",
            degrees_2: "",
            password: "",
            verify: "",
            email: "",
            phone: "",
            acceptTerms: true,
          },
          form_reg_valid: false,
          form_forgot: {
            email: "",
          },
          g_form: {
            g_username: "",
            g_password: "",
            g_clientid: "",
          },
        }
      },

    // watch: {
    //   subject: {
    //     handler: 'test_watch',
    //     immediate: true
    //   },
    // },


    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      Modal,
      ValidationProvider,
      ValidationObserver,
      // UserMenu,
    },

    computed: {
      ...mapState({
        modal_login: state => state.modal_login,
        modal_reg: state => state.modal_reg,
        modal_forgot: state => state.modal_forgot,
        // modal_gisaid: state => state.modal_gisaid,
        modal_info: state => state.modal_info,
        modal_info_text: state => state.modal_info_text,
        email: state => state.email,
        token: state => state.token,
        subject: state => state.subject,
      }),

      ...mapGetters({

      }),

      modal_gisaid: {
        get () {
          return this.$store.state.modal_gisaid;
        },
        set (value) {
          if (value) {
              this.g_form.g_username = this.subject.gisaid_username;
              this.g_form.g_password = this.subject.gisaid_password;
              this.g_form.g_clientid = this.subject.gisaid_clientid;
          }
          this.$store.commit('m_modal_gisaid', value);
        }
      },

    },

    methods: {
      ...mapMutations({
        m_modal_login: 'm_modal_login',
        m_modal_reg: 'm_modal_reg',
        m_modal_forgot: 'm_modal_forgot',
        m_modal_gisaid: 'm_modal_gisaid',
        m_modal_info: 'm_modal_info',
        m_modal_info_text: 'm_modal_info_text',
        m_login: 'm_login',

      }),

      // test_watch () {
      //   if (this.subject.id_subject === 0 && this.token > "") {
      //     this.a_load_profile();

      //   } else {
      //     console.log("BBBB");
      //   }
      // },

      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },


      handle_close_modal () {

      },



      login () {
        // console.log(this.form.email);
        // console.log(this.form.password);
        // this.m_login(this.form.email, this.form.password);
        // this.form.email = ""
        // this.form.password = ""
        // this.m_modal_login(false);
      },

      ...mapActions({
        a_login: 'a_login',
        a_reg: 'a_reg',
        a_load_profile: 'a_load_profile',
        a_gisaid: 'a_gisaid',

      }),


      onSubmit_reg () {
        this.a_reg({
          degrees_1     : this.form_reg.degrees_1,
          firstName     : this.form_reg.firstName,
          lastName      : this.form_reg.lastName,
          degrees_2     : this.form_reg.degrees_2,
          email         : this.form_reg.email,
          phone         : this.form_reg.phone,
          password      : this.form_reg.password,
          verify        : this.form_reg.verify,
          acceptTerms   : this.form_reg.acceptTerms
        });
      },


    },



    mounted () {
      this.g_form.g_username = this.subject.gisaid_username;
      this.g_form.g_password = this.subject.gisaid_password;
      this.g_form.g_clientid = this.subject.gisaid_clientid;
    },


  }


</script>
<style lang="scss">
#myVideo {
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
}

.main-panel {
  padding-left: 260px !important;
}

.full-panel {
  padding-left: 0px !important;
  padding-right: 0px !important;
}


.main-panel > .content {
    min-height: calc(100vh - 10px) !important;
}

.modal-dialog {
    padding-top: 100px !important;
    max-width: 1200px !important;
    min-height: 800px !important;
}

.modal {
  // z-index: 5999 !important;
}

.mylabel {
  min-width: 120px !important;
  margin-top: 10px !important;
}

</style>
